module.exports = __webpack_public_path__ + "static/media/house.a7f76cbd.jpg";